<template>
  <div class="index" v-bind:style="{backgroundImage:'url(' + bg_img + ')'}">
      <h3 ref="title" class="animated zoomInDown">我们的<span>成长</span></h3>
      <div @click="goNext()" ref="button" class="button-bg animated rotateInUpLeft" v-bind:style="{backgroundImage:'url(' + button_img + ')'}">
          点击放送
      </div>
      <img class="index-bottom" src="https://cdn.hanlandglobal.com/h5-grow-bg2.png" />
  </div>
</template>

<script>
// @ is an alias to /src
import bg_img from '../assets/image/grow-bg.jpg'
import button_img from '../assets/image/button-bg.png'

export default {
  name: 'GrowUp',
  data(){
    return {
      bg_img,
      button_img
    }
  },
  mounted(){

  },
  methods:{
     goNext(){
        this.$refs.title.className = 'animated fadeOutRight'
        this.$refs.button.className = 'button-bg animated fadeOutRight'
        setTimeout(()=>{
          this.$router.push('/growUp2')
        },600)
      }
  }
}
</script>
<style lang='scss' scoped>
.index{
  width: 100%;
  height: 100vh;
  background-repeat: no-repeat;
  background-size: 100% 100vh;
  position: relative;
}
h3{
  font-size: 0.54rem;
  font-family: SourceHan;
  color: #4d372e;
  text-align: center;
  letter-spacing: 1px;
  padding-top:13vh;
  span{
    font-size: 0.72rem;
  }
}
.index-bottom{
  width: 100%;
  height: calc(100vh - 5.2rem);
  height: -webkit-calc(100vh - 5.2rem);
  max-height: 8.2rem;
  position: absolute;
  left: 0;
  bottom: 0;
}
.button-bg{
  width: 2rem;
  height: 0.62rem;
  background-repeat: no-repeat;
  background-size: 2rem 0.62rem;
  margin:0 auto;
  color: #f8eed5;
  font-size: 0.32rem;
  line-height: 0.58rem;
  margin-top: 1.3rem;
  font-weight: 700;
  font-family: SourceHan;
}
</style>
